import React from "react";

export function PageHeader({ title, subtitle, action, testId }) {
  return (
    <div className="flex items-start justify-between mb-8 animate-fade-up" data-testid={testId}>
      <div>
        <h1 className="font-heading text-3xl font-black tracking-tighter text-gray-900">{title}</h1>
        {subtitle && <p className="text-sm text-gray-500 mt-1">{subtitle}</p>}
      </div>
      {action && <div>{action}</div>}
    </div>
  );
}

export function StatCard({ label, value, icon: Icon, testId }) {
  return (
    <div className="card-base p-6 hover:shadow-md transition-shadow" data-testid={testId}>
      <div className="flex items-center justify-between mb-3">
        <span className="text-xs font-semibold uppercase tracking-wider text-gray-500">{label}</span>
        {Icon && <Icon size={18} className="text-brand" strokeWidth={2} />}
      </div>
      <div className="font-mono text-3xl font-bold text-gray-900">{value}</div>
    </div>
  );
}

export function Empty({ title = "Nothing here yet", subtitle, action }) {
  return (
    <div className="text-center py-16 border border-dashed border-gray-200 rounded-lg bg-white">
      <div className="font-heading text-lg font-semibold text-gray-900">{title}</div>
      {subtitle && <div className="text-sm text-gray-500 mt-1">{subtitle}</div>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}

export function Badge({ children, variant = "default" }) {
  const styles = {
    default: "bg-gray-100 text-gray-700",
    success: "bg-emerald-50 text-emerald-700 border border-emerald-200",
    warning: "bg-amber-50 text-amber-700 border border-amber-200",
    danger: "bg-red-50 text-red-700 border border-red-200",
    brand: "bg-brand-light text-brand",
  };
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-semibold ${styles[variant] || styles.default}`}>
      {children}
    </span>
  );
}
